// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalBg {
  position: fixed;
  z-index: 1;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7019607843);
  backdrop-filter: blur(3px);
}
.modalBg .modalContainer {
  max-width: 95%;
  max-height: 95%;
  width: 80%;
  height: 90%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  background-color: var(--Foreground);
  border-radius: 1.25rem;
  padding: 1.25rem;
  gap: 0.6rem;
}
.modalBg .modalContainer .header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
}
.modalBg .modalContainer .header h1 {
  flex: 1 1 15rem;
  color: var(--AccentColor);
  font-size: 1.25rem;
  font-weight: 600;
}
.modalBg .modalContainer .header div {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 1rem;
}
.modalBg .modalContainer .header div button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  height: 2rem;
  min-width: 5rem;
}
.modalBg .modalContainer .header div button img {
  width: 0.875rem;
  height: 0.875rem;
}
.modalBg .modalContainer .header div button:first-child {
  background-color: #CCCAD4;
  color: black;
}
.modalBg .modalContainer .header div button:last-child {
  background-color: var(--AccentColor);
  color: white;
  padding: 0 1.5rem;
}
.modalBg .modalContainer .containerBody {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.6rem;
  overflow: auto;
}
.modalBg .modalContainer .containerBody .leftSide {
  flex: 1 1 23rem;
  height: 100%;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.6rem;
  padding: 0.6rem;
  display: flex;
  flex-direction: column;
}
.modalBg .modalContainer .containerBody .leftSide h1 {
  color: var(--TextColor);
  font-size: 1.25rem;
}
.modalBg .modalContainer .containerBody .leftSide .pdfViewer {
  width: 100% !important;
  flex: 1 1;
  display: flex;
  overflow: auto;
  flex-direction: column;
}
.modalBg .modalContainer .containerBody .leftSide .pdfViewer .NoPrev {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.125rem;
  text-wrap: pretty;
  color: var(--TextColor);
}
.modalBg .modalContainer .containerBody .leftSide .pdfViewer img {
  max-width: 100%;
}
.modalBg .modalContainer .containerBody .rightSide {
  flex: 3 1 23rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  overflow: auto;
}
.modalBg .modalContainer .containerBody .rightSide .packDetails {
  width: 100%;
  padding: 0.6rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.6rem;
}
.modalBg .modalContainer .containerBody .rightSide .packDetails .planInfo {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.modalBg .modalContainer .containerBody .rightSide .packDetails .planInfo > :nth-child(1) {
  font-size: 1.25rem;
  color: var(--TextColor);
  font-weight: 600;
}
.modalBg .modalContainer .containerBody .rightSide .packDetails .planInfo > :nth-child(2) {
  font-size: 0.75rem;
  font-weight: 600;
  color: #9B9B9B;
}
.modalBg .modalContainer .containerBody .rightSide .packDetails .planInfo > :nth-child(3) {
  font-size: 1rem;
  color: var(--AccentColor);
  font-weight: 700;
}
.modalBg .modalContainer .containerBody .rightSide .packDetails .priceInfo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
}
.modalBg .modalContainer .containerBody .rightSide .packDetails .priceInfo > :nth-child(1) {
  font-size: 1.5rem;
  text-wrap: nowrap;
  font-weight: 600;
  color: var(--TextColor);
}
.modalBg .modalContainer .containerBody .rightSide .packDetails .priceInfo > :nth-child(2) {
  font-size: 0.8rem;
  color: #9B9B9B;
}
.modalBg .modalContainer .containerBody .rightSide .packDetailsContainer {
  flex: 1 1;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 0.6rem;
  overflow: auto;
}
.modalBg .modalContainer .containerBody .rightSide .packDetailsContainer h1, .modalBg .modalContainer .containerBody .rightSide .packDetailsContainer p {
  color: var(--TextColor);
}
.modalBg .modalContainer .containerBody .rightSide .packDetailsContainer .packageDetails {
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.6rem;
  width: 50%;
  padding: 0.6rem;
  gap: 0.6rem;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.modalBg .modalContainer .containerBody .rightSide .packDetailsContainer .userDetails {
  flex: 1 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.modalBg .modalContainer .containerBody .rightSide .packDetailsContainer .userDetails h1 {
  font-size: 1rem;
}
.modalBg .modalContainer .containerBody .rightSide .packDetailsContainer .userDetails .planNames {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.6rem;
}
.modalBg .modalContainer .containerBody .rightSide .packDetailsContainer .userDetails .planNames p {
  font-size: 0.75rem;
}
.modalBg .modalContainer .containerBody .rightSide .packDetailsContainer .userDetails .userCred {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  justify-content: space-between;
  overflow: auto;
}
.modalBg .modalContainer .containerBody .rightSide .packDetailsContainer .userDetails .userCred div p {
  font-size: 0.75rem;
  margin: 0;
  color: #9b9b9b;
}
.modalBg .modalContainer .containerBody .rightSide .packDetailsContainer .userDetails .userCred div input {
  padding: 0.6rem 0rem;
  border: none;
  width: 100%;
  text-indent: 0.5rem;
  color: var(--TextColor);
  outline: none;
  border-bottom: 0.0625rem solid var(--Stroke);
  background-color: transparent;
  font-size: 0.875rem;
}
.modalBg .modalContainer .containerBody .rightSide .packDetailsContainer .Type {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.modalBg .modalContainer .containerBody .rightSide .packDetailsContainer .Type h1 {
  font-size: 1rem;
  font-weight: 700;
}
.modalBg .modalContainer .containerBody .rightSide .packDetailsContainer .Type p {
  font-size: 0.75rem;
  text-wrap: pretty;
}

@media (max-width: 680px) {
  .modalBg .modalContainer {
    width: 90%;
  }
  .modalBg .modalContainer .containerBody .leftSide {
    order: 1;
    height: auto;
  }
  .modalBg .modalContainer .containerBody .rightSide {
    order: 0;
    height: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/BeginVerification/Modal/PlanDetailsModal.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,MAAA;EACA,OAAA;EACA,uCAAA;EACA,0BAAA;AACJ;AAAI;EACI,cAAA;EACA,eAAA;EAGA,UAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mCAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AAAR;AACQ;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AACZ;AAAY;EACI,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAEhB;AAAY;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;AAEhB;AADgB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAGpB;AAFoB;EACI,eAAA;EACA,gBAAA;AAIxB;AAFoB;EACI,yBAAA;EAEA,YAAA;AAGxB;AADoB;EACI,oCAAA;EACA,YAAA;EACA,iBAAA;AAGxB;AAEQ;EACI,SAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;AAAZ;AACY;EACI,eAAA;EACA,YAAA;EACA,qCAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AAChB;AAAgB;EACI,uBAAA;EACA,kBAAA;AAEpB;AAAgB;EACI,sBAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;AAEpB;AADoB;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;AAGxB;AADoB;EACE,eAAA;AAGtB;AACY;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;AAChB;AAAgB;EACI,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,qCAAA;EACA,qBAAA;AAEpB;AADoB;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AAGxB;AAFwB;EACI,kBAAA;EACA,uBAAA;EACA,gBAAA;AAI5B;AAFwB;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;AAI5B;AAFwB;EACI,eAAA;EACA,yBAAA;EACA,gBAAA;AAI5B;AADoB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAGxB;AAFwB;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AAI5B;AAFwB;EACI,iBAAA;EACA,cAAA;AAI5B;AAEgB;EACI,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AAApB;AACoB;EACI,uBAAA;AACxB;AACoB;EACI,qCAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;EAEA,WAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AAAxB;AAEoB;EACI,SAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAAxB;AACwB;EACE,eAAA;AAC1B;AACwB;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAC5B;AAA4B;EACE,kBAAA;AAE9B;AACwB;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,8BAAA;EACA,cAAA;AAC5B;AACgC;EACI,kBAAA;EACA,SAAA;EACA,cAAA;AACpC;AACgC;EACI,oBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,4CAAA;EACA,6BAAA;EACA,mBAAA;AACpC;AAIoB;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAFtB;AAGsB;EACE,eAAA;EACA,gBAAA;AADxB;AAGsB;EACE,kBAAA;EACA,iBAAA;AADxB;;AAUA;EAEI;IACE,UAAA;EARJ;EAUM;IACE,QAAA;IACA,YAAA;EARR;EAUM;IACE,QAAA;IACA,YAAA;EARR;AACF","sourcesContent":[".modalBg{\n    position: fixed;\n    z-index: 1;\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    top: 0;\n    left: 0;\n    background: #000000b3;\n    backdrop-filter: blur(3px);\n    .modalContainer{\n        max-width: 95%;\n        max-height: 95%;\n        // min-width: 70%;\n        // min-height: 70%;\n        width: 80%;\n        height: 90%;\n        overflow: auto;\n        display: flex;\n        flex-direction: column;\n        background-color: var(--Foreground);\n        border-radius: 1.25rem;\n        padding: 1.25rem;\n        gap: .6rem;\n        .header{\n            display: flex;\n            align-items: center;\n            justify-content: flex-end;\n            flex-wrap: wrap;\n            h1{\n                flex: 1 1 15rem;\n                color: var(--AccentColor);\n                font-size: 1.25rem;\n                font-weight: 600;\n            }\n            div{\n                display: flex;\n                flex-direction: row;\n                align-items: center;\n                justify-content: flex-end;\n                flex-wrap: wrap;\n                gap: 1rem;\n                button{\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    gap: 0.5rem;\n                    border-radius: .25rem;\n                    font-size: 0.875rem;\n                    height: 2rem;\n                    min-width: 5rem;\n                    img{\n                        width: 0.875rem;\n                        height: 0.875rem;\n                    }\n                    &:first-child{\n                        background-color: #CCCAD4;\n                        // color: var(--TextColor);\n                        color: black;\n                    }\n                    &:last-child{\n                        background-color: var(--AccentColor);\n                        color: white;\n                        padding: 0 1.5rem;\n                    }\n                }\n            }\n        }\n        .containerBody{\n            flex: 1;\n            display: flex;\n            flex-direction: row;\n            flex-wrap: wrap;\n            gap: .6rem;\n            overflow: auto;\n            .leftSide{\n                flex: 1 30rem 23rem;\n                height: 100%;\n                border: 0.0625rem solid var(--Stroke);\n                border-radius: .6rem;\n                padding: .6rem;\n                display: flex;\n                flex-direction: column;\n                h1{\n                    color: var(--TextColor);\n                    font-size: 1.25rem;\n                }\n                .pdfViewer{\n                    width: 100% !important;\n                    flex: 1 1;\n                    display: flex;\n                    overflow: auto;\n                    flex-direction: column;\n                    .NoPrev{\n                        width: 100%;\n                        height: 100%;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        font-size: 1.125rem;\n                        text-wrap: pretty;\n                        color: var(--TextColor);\n                    }\n                    img{\n                      max-width: 100%;\n                    }\n                }\n            }\n            .rightSide{\n                flex: 3 30rem 23rem;\n                height: 100%;\n                display: flex;\n                flex-direction: column;\n                gap: .6rem;\n                overflow: auto;\n                .packDetails{\n                    width: 100%;\n                    padding: .6rem;\n                    display: flex;\n                    flex-direction: row;\n                    align-items: center;\n                    justify-content: space-between;\n                    border: 0.0625rem solid var(--Stroke);\n                    border-radius: .6rem;\n                    .planInfo{\n                        display: flex;\n                        flex-direction: column;\n                        gap: .6rem;\n                        & >:nth-child(1){\n                            font-size: 1.25rem;\n                            color: var(--TextColor);\n                            font-weight: 600;\n                        }\n                        & >:nth-child(2){\n                            font-size: 0.75rem;\n                            font-weight: 600;\n                            color: #9B9B9B;\n                        }\n                        & >:nth-child(3){\n                            font-size: 1rem;\n                            color: var(--AccentColor);\n                            font-weight: 700;\n                        }\n                    }\n                    .priceInfo{\n                        display: flex;\n                        flex-direction: column;\n                        align-items: center;\n                        justify-content: center;\n                        gap: .6rem;\n                        & > :nth-child(1){\n                            font-size: 1.5rem;\n                            text-wrap: nowrap;\n                            font-weight: 600;\n                            color: var(--TextColor);\n                        }\n                        & > :nth-child(2){\n                            font-size: .8rem;\n                            color: #9B9B9B;\n                            // text-wrap: nowrap;\n                            // font-weight: 600;\n                        }\n                    }\n                }\n                .packDetailsContainer{\n                    flex: 1;\n                    width: 100%;\n                    display: flex;\n                    flex-direction: row;\n                    gap: .6rem;\n                    overflow: auto;\n                    h1,p{\n                        color: var(--TextColor);\n                    }\n                    .packageDetails{\n                        border: 0.0625rem solid var(--Stroke);\n                        border-radius: .6rem;\n                        width: 50%;\n                        padding: .6rem;\n                        // height: 100%;\n                        gap: .6rem;\n                        overflow: auto;\n                        display: flex;\n                        flex-direction: column;\n                    }\n                    .userDetails{\n                        flex: 1;\n                        overflow: auto;\n                        display: flex;\n                        flex-direction: column;\n                        gap: .6rem;\n                        h1{\n                          font-size: 1rem;\n                        }\n                        .planNames{\n                            display: flex;\n                            flex-direction: row;\n                            align-items: center;\n                            gap: .6rem;\n                            p{\n                              font-size: 0.75rem;\n                            }\n                        }\n                        .userCred{\n                            display: flex;\n                            flex-direction: column;\n                            gap: .6rem;\n                            justify-content: space-between;\n                            overflow: auto;\n                            div{\n                                p{\n                                    font-size: .75rem;\n                                    margin: 0;\n                                    color: #9b9b9b;\n                                }\n                                input{\n                                    padding: .6rem 0rem;\n                                    border: none;\n                                    width: 100%;\n                                    text-indent: 0.5rem;\n                                    color: var(--TextColor);\n                                    outline: none;\n                                    border-bottom: 0.0625rem solid var(--Stroke);\n                                    background-color: transparent;\n                                    font-size: .875rem;\n                                }\n                            }\n                        }\n                    }\n                    .Type{\n                      display: flex;\n                      flex-direction: column;\n                      gap: 0.25rem;\n                      h1{\n                        font-size: 1rem;\n                        font-weight: 700;\n                      }\n                      p{\n                        font-size: 0.75rem;\n                        text-wrap: pretty;\n                      }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@media (max-width: 680px) {\n  .modalBg{\n    .modalContainer{\n      width: 90%;\n      .containerBody{\n        .leftSide{\n          order: 1;\n          height: auto;\n        }\n        .rightSide{\n          order: 0;\n          height: auto;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
